import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Product} from './product';
import * as fromStore from "../../store";
import {filter, switchMap} from "rxjs/operators";

import {Store} from "@ngrx/store";

@Injectable()
export class SeoPluginResolver implements Resolve<Product|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data['website'].id;
      this._store.select(fromStore.getWebsitePluginsLoaded(websiteId))
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getWebsiteSeoPlugin(websiteId)))
        )
        .subscribe((seoPlugin) => {
          if (seoPlugin) {
            resolve(seoPlugin);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
